module.exports = __webpack_public_path__ + "media/images/contest_rectangle-33f66b51e367c300dc7b9dcaab89e5c1.svg";